export const Selectors = {
    bannerSlider: 'tx_igslider_bannerslider'
};